function getAssignedUid(shift = {}) {
  return (
    shift.assignedWorkerUid ||
    shift.workerUid ||
    shift.workerId ||
    (Array.isArray(shift.assignedWorkerUids) ? shift.assignedWorkerUids[0] : "") ||
    ""
  );
}

export function calculateReliabilityScore(worker = {}, shifts = []) {
  const performance = worker.performance || {};
  const workerUid = worker.uid || worker.id || "";

  const shiftRows = Array.isArray(shifts) ? shifts : [];

  const workerShifts = workerUid
    ? shiftRows.filter((s) => getAssignedUid(s) === workerUid)
    : [];

  const completedFromShifts = workerShifts.filter(
    (s) => String(s.status || "").toLowerCase() === "completed"
  ).length;

  const noShowsFromShifts = workerShifts.filter(
    (s) => String(s.status || "").toLowerCase() === "no_show"
  ).length;

  const lateActivationsFromShifts = workerShifts.filter(
  (s) => s.activatedLate === true
).length;

  const completedShifts =
    completedFromShifts || Number(performance.completedShifts || 0);

  const noShows =
    noShowsFromShifts || Number(performance.noShows || 0);

  const lateArrivals =
  lateActivationsFromShifts || Number(performance.lateArrivals || 0);
  const cancelledLate = Number(performance.cancelledLate || 0);

  let score = 100;

  score -= noShows * 20;
  score -= lateArrivals * 5;
  score -= cancelledLate * 10;

  if (completedShifts >= 10) score += 3;
  if (completedShifts >= 25) score += 2;

  return Math.max(0, Math.min(100, score));
}

export function getReliabilityLabel(score) {
  if (score >= 90) return "Excellent";
  if (score >= 75) return "Good";
  if (score >= 60) return "Watch";
  return "High Risk";
}